// extracted by mini-css-extract-plugin
export default {"leftSide":"LeftSide_leftSide__w+RJJ","header":"LeftSide_header__Y9Cit","chatsContainer":"LeftSide_chatsContainer__W2hir"};